import { PURCHASE_ORDER_DETAIL_PAGE } from "routes/route.constant";
import DetailPurchaseOrder from "./DetailPurchaseOrder";

const route = {
  path: PURCHASE_ORDER_DETAIL_PAGE,
  element: DetailPurchaseOrder,
};

export default route;
